/* eslint-disable babel/camelcase */
import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  container: {
    backgroundColor: 'white',
    position: 'relative',
    textAlign: 'left',
    fontFamily: 'Lato, Arial, sans-serif',
    ' *': {
      boxSizing: 'border-box'
    }
  },
  horizontal: {
    backgroundColor: 'white',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)',
    borderRadius: 3
  },
  vertical: {
    position: 'initial',
    ' [role="presentation"] ul': {
      left: '50%'
    }
  },
  verticalScrollable: {
    height: '100%',
    ' [role="presentation"] ul': {
      top: 0,
      display: 'table-row',
      borderColor: 'lightgrey',
      borderStyle: 'solid',
      borderBottomWidth: 1,
      backgroundColor: 'white',
      marginLeft: 0,
      left: 0,
      width: '100%',
      textAlign: 'center'
    }
  },
  transition: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 3
  },
  transition_horizontal: {
    transition: 'height 200ms ease-in-out'
  },
  transition_vertical: {
    width: '100%'
  },
  transition_verticalScrollable: {
    position: 'absolute',
    paddingTop: 20,
    width: '100%',
    height: '100%',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    overflowY: 'scroll'
  },
  region: {
    outline: 'none'
  },
  weekHeader: {
    color: 'darkgrey',
    position: 'absolute',
    top: 62,
    fontSize: '0.75em',
    zIndex: 3,
    padding: '0 13px',
    textAlign: 'center',
    listStyle: 'none',
    margin: '1px 9px',
    paddingLeft: 0,
    paddingRight: 0,
    '> li': {
      display: 'inline-block',
      textAlign: 'center'
    }
  },
  headers: {
    position: 'relative'
  },
  withPortal: {
    boxShadow: 'none',
    position: 'absolute',
    left: '50%',
    top: '50%'
  }
});